import React from 'react';
export function CTASection() {
  return <section className="mb-16" data-id="element-9">
      <div className="bg-gradient-to-br from-teal-600 to-teal-700 text-white p-8 rounded-lg text-center shadow-lg" data-id="element-10">
        <p className="text-xl mb-8" data-id="element-11">
          If you've felt stuck — even after therapy or other healing work —
          retraining your vagus nerve might be the missing piece.
        </p>
        <a href="https://www.neurotoned.com/41-off-neuro" className="inline-block bg-white text-teal-700 font-bold py-4 px-8 rounded-lg text-xl shadow-lg hover:bg-gray-100 transition-all hover:scale-105 mb-8" data-id="element-12">
          How To Reset Your Vagus Nerve
        </a>
        <p className="text-lg mb-8" data-id="element-13">
          You don't have to keep talking about your trauma to help your body
          feel safe again.
        </p>
        <p className="text-lg mb-8" data-id="element-14">
          Sometimes it's about giving the nervous system a new experience — one
          that says:
        </p>
        <div className="bg-teal-500 p-6 rounded-lg mb-8 max-w-lg mx-auto" data-id="element-15">
          <p className="text-xl italic" data-id="element-16">
            "You're safe now. You can come out of survival."
          </p>
        </div>
        <a href="https://www.neurotoned.com/41-off-neuro" className="inline-block bg-white text-teal-700 font-bold py-4 px-8 rounded-lg text-xl shadow-lg hover:bg-gray-100 transition-all hover:scale-105" data-id="element-17">
          How To Reset Your Vagus Nerve
        </a>
      </div>
    </section>;
}